import { Component, OnInit, inject } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { filter } from 'rxjs/operators';

import { SideNavComponent } from '../Layout/side-nav/side-nav.component';
import { AuthService } from './modules/auth/auth.service';
import { AppDataService } from './core/services/app-data.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, SideNavComponent],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  private router = inject(Router);
  private readonly auth = inject(AuthService);
  private readonly appData = inject(AppDataService);

  title = 'ims-frontend';
  sideNavOpen = false;
  showShell = false;

  ngOnInit() {
    this.updateShellVisibility(this.router.url);

    if (this.auth.isAuthenticated()) {
      this.appData.refreshAll();
    }

    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event) => {
        const navigation = event as NavigationEnd;
        this.updateShellVisibility(navigation.urlAfterRedirects);
        this.sideNavOpen = false;
      });
  }

  toggleSideNav() {
    this.sideNavOpen = !this.sideNavOpen;
  }

  closeSideNav() {
    this.sideNavOpen = false;
  }

  private updateShellVisibility(url: string) {
    const path = url.split('?')[0] || '/';
    const authPaths = ['/', '/login', '/otp', '/forgot-password', '/reset-password'];
    this.showShell = !authPaths.includes(path);
  }
}
